const hasStorage = () => {
    try {
		localStorage.setItem('bf20', 'bf20');
		localStorage.removeItem('bf20');
		window.bf20.hasStorage = true;
	} catch (exception) {
		window.bf20.hasStorage = false;
	}
}

export default hasStorage;